import {
  NBS_API_REPORT_USER_REQUEST,
  NBS_API_REPORT_USER_SUCCESS,
  NBS_API_REPORT_USER_FAILURE
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_REPORT_USER_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request'
      };
    case NBS_API_REPORT_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        timestamp: new Date().toUTCString(),
        status: 'success'
      };
    case NBS_API_REPORT_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail'
      };
    default:
      return state;
  }
}
